import React from "react";
import { useAuth } from "@/context/AuthContext";
import Icon from "@/components/Icon";
import { Dropdown, Space } from "antd";
import { RemoveCookie } from "@/service/CookieService";
import { TOKEN_NAME } from "@/constants/token.const";
import { useNavigate } from "react-router-dom";
import { processList } from "@/constants/process-list";
import { useMenu } from "@/context/MenuContext";
import { useTranslation } from "react-i18next";

export function UserMenu({ className, ...props }) {
    const { auth, api, setAuth } = useAuth();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { onMenuClose } = useMenu();

    const items = [
        {
            label: (
                <div
                    className={"hover:cursor-pointer flex gap-2 items-center"}
                    onClick={() => {
                        navigate("/profile");
                    }}
                >
                    <Icon name={"User"} /> {t("profile")}
                </div>
            ),
            key: "Profile",
        },
        {
            label: (
                <div
                    className={"hover:cursor-pointer flex gap-2 items-center"}
                    onClick={() => {
                        let lng = i18n.language === "mn" ? "en" : "mn";
                        i18n.changeLanguage(lng);

                        localStorage.setItem('i18nextLngMeLp', lng);
                        // navigate('/profile?activeTab=password');
                    }}
                >
                    <Icon name={"Globe"} /> {i18n.language === "mn" ? t("english") : t("mongolian")}
                </div>
            ),
            key: "changeLanguage",
        },
        {
            label: (
                <div
                    className={"hover:cursor-pointer flex gap-2 items-center"}
                    onClick={() => {
                        navigate("/profile?activeTab=password");
                    }}
                >
                    <Icon name={"Lock"} /> {t('change password')}
                </div>
            ),
            key: "ChangePass",
        },
        {
            type: "divider",
        },
        {
            label: (
                <div
                    className={"hover:cursor-pointer flex gap-2 items-center"}
                    onClick={() => {
                        onLogout();
                    }}
                >
                    <Icon name={"LogOut"} /> {t('logout')}
                </div>
            ),
            key: "Logout",
        },
    ];

    const onLogout = async () => {
        setAuth({});
        await api(processList.logout, {});
        RemoveCookie(TOKEN_NAME);
        localStorage.setItem("MeCoreTokenTime", 0);
        sessionStorage.clear();
        navigate("/login");
    };

    return (
        <div
            onClick={() => {
                onMenuClose();
            }}
        >
            <div className="w-full flex-1 md:w-auto md:flex-none"></div>
            <nav className="flex items-center">
                <Dropdown
                    menu={{
                        items,
                    }}
                >
                    <Space className={"hover:cursor-pointer"}>
                        <Icon name={"UserCircle"} />
                        {auth.user.email}
                        {auth.user.instname ? <span>({auth.user.instname})</span> : <></>}
                        <Icon name={"ChevronDown"} />
                    </Space>
                </Dropdown>
            </nav>
        </div>
    );
}
